<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.proveedor,
      }"
      >Super Cliente</label
    >
    <v-select
      label="nombre"
      v-model="current.super_cliente"
      :disabled="disabled"
      @input="onChangeCliente($event)"
      :filterable="false"
      :options="clientes"
      @search="onSearch"
    >
      <template slot="no-options">Cliente...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.nit }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
      >{{ current.errors.proveedor }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: ["current", "disabled"],
  data() {
    return {
      clientes: [],
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      let self = this;
      DynamicService.fetch("cat", "super-cliente", {
        page: 1,
      }).then((res) => {
        self.clientes = res.data.results;
      });
    },
    onChangeCliente(event) {
      this.$emit("onChangeCliente", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "super-cliente", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.clientes = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>0
